__turbopack_context__.v({
  "animated": "BackgroundSketchContainer-module-scss-module__BAVpMW__animated",
  "art": "BackgroundSketchContainer-module-scss-module__BAVpMW__art",
  "atom": "BackgroundSketchContainer-module-scss-module__BAVpMW__atom",
  "background": "BackgroundSketchContainer-module-scss-module__BAVpMW__background",
  "ball": "BackgroundSketchContainer-module-scss-module__BAVpMW__ball",
  "container": "BackgroundSketchContainer-module-scss-module__BAVpMW__container",
  "content": "BackgroundSketchContainer-module-scss-module__BAVpMW__content",
  "drawing": "BackgroundSketchContainer-module-scss-module__BAVpMW__drawing",
  "image": "BackgroundSketchContainer-module-scss-module__BAVpMW__image",
  "lightbulb": "BackgroundSketchContainer-module-scss-module__BAVpMW__lightbulb",
  "math": "BackgroundSketchContainer-module-scss-module__BAVpMW__math",
  "music": "BackgroundSketchContainer-module-scss-module__BAVpMW__music",
  "planet": "BackgroundSketchContainer-module-scss-module__BAVpMW__planet",
  "science": "BackgroundSketchContainer-module-scss-module__BAVpMW__science",
  "tech": "BackgroundSketchContainer-module-scss-module__BAVpMW__tech",
});
